var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5H9a.5.5 0 0 1-.5-.5V4c0-.275.225-.5.5-.5h4.378L15.5 5.622V12c0 .275-.225.5-.5.5M9 14h6c1.103 0 2-.897 2-2V5.622a1.5 1.5 0 0 0-.44-1.06l-2.12-2.121A1.5 1.5 0 0 0 13.382 2H9c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2M5 6c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2v-1h-1.5v1c0 .275-.225.5-.5.5H5a.5.5 0 0 1-.5-.5V8c0-.275.225-.5.5-.5h1V6z"
  })));
};
export default SvgCopy;